<template>
  <div>
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <div v-else-if="is_no_records == 1">
      <GlobalEmptyRecord RouteName="PriceListCreate">
        <template slot="title">
          <h2>Create Price list and make your customer happy</h2>
        </template>
        <template slot="content">
          <span style="color:gray">Make your clients more happier by using price list</span>
        </template>
        <template slot="page">New Price List</template>
      </GlobalEmptyRecord>
    </div>

    <div class="Invoice-page" v-else style="margin-top:-10px !important">
      <b-row class="px-pad border-bottom" style="height:42px">
        <b-col md="6" lg="6" sm="6" class="px-0">
          <!-- <b-dropdown
          variant="link"
          class="index-filter-heading"
          size="sm"
          dropdown
          toggle-class="text-decoration-none"
          :text="filter_name"
        >
          <div class="dropdownitem-list">
            <b-dropdown-item
              :class="{'filter_dropdown' : true}"
              :to="{ name : 'PriceList',query: {search:'',status:item.status_id,sort:sort,label:label} }"
              v-for="item in filter_list"
              :key="item.status_id"
              v-if="item.status_name != filter_name"
            >{{ item.status_name }}</b-dropdown-item>
          </div>
          </b-dropdown>-->
          <span class="fw-semi-bold index-heading pl-0">{{ filter_name }}</span>
        </b-col>
        <b-col md="6" lg="6" sm="6" class="text-right px-0">
          <router-link
            class="btn btn-primary"
            :to="{ name: 'PriceListCreate' }"
            v-if="RoutePermission(false, '', '', 'pricelists', 'create')"
          >New Price List</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="px-0">
          <b-alert
            class="alert-transparent alert-shade mx-mar mt-3"
            :show="this.$route.params.search == '' ? false : true"
          >
            <router-link
              class="text-dark float-right"
              :to="{
              name: 'PriceList',
              query: { status: '', sort: sort, label: label },
            }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </router-link>
            <p>
              <span class="fw-semi-bold">Pricelist Name :</span>
              {{ this.$route.query.search }}
            </p>
          </b-alert>

          <!-- Table for details -->
          <div class="table-responsive min-table">
            <table class="table table-hover index-table">
              <thead>
                <tr>
                  <th
                    class="text-left"
                    style="padding-left: 1.7rem !important;width:200px !important"
                  >Name</th>
                  <th class="text-left" style="width:250px !important">Description</th>
                  <th class="text-left" style="width:140px !important">Currency</th>
                  <th class="text-left" style="width:140px !important">Details</th>
                  <th class="text-left" style="width:140px !important">Pricing Scheme</th>
                  <th class="text-left" style="width:140px !important">Rounding</th>
                  <th class="text-left" style="width:100px !important">Status</th>
                  <th
                    class="text-right"
                    style="width:30px !important"
                    v-if="
                        RoutePermission(false, '', '', 'pricelists', 'update')
                      "
                  ></th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="lists.length == 0">
                  <td colspan="7" class="text-center">No data to display</td>
                </tr>
                <tr
                  v-else
                  :class="{ 'text-muted': item.status == 0 }"
                  v-for="item in lists"
                  :key="item.pricing_hdr_id"
                >
                  <td
                    class="text-left"
                    style="padding-left: 1.7rem !important;width:200px !important"
                  >
                    <router-link
                      class="text-link"
                      :to="{
                      name: 'PriceListUpdate',
                      params: { id: item.pricing_hdr_id },
                    }"
                      v-if="RoutePermission(false, '', '', 'pricelists', 'update')"
                    >
                      <span class="text pr-3">{{ item.pricing_name }}</span>
                    </router-link>
                    <template v-else>
                      <span class="text pr-3">{{ item.pricing_name }}</span>
                    </template>
                  </td>
                  <td class="text-left" style="width:250px !important">
                    <span class="text pr-3">{{ item.pricing_desc }}</span>
                  </td>
                  <td class="text-left">
                    {{
                    getDetails(
                    $AppDetails.currency_details,
                    item.currency_id,
                    "currency_code"
                    )
                    }}
                  </td>
                  <td class="text-left">{{ item.pricing_details }}</td>
                  <td class="text-left">{{ item.pricing_scheme }}</td>
                  <td class="text-left">
                    {{
                    getPresentValue(
                    details.rounding_type,
                    "value",
                    item.rounding_type,
                    "label"
                    )
                    }}
                  </td>
                  <td>
                    <b-badge
                      :variant="item.status==1?'primary':'default'"
                    >{{item.status==0?'Inactive':'Active'}}</b-badge>
                  </td>
                  <td
                    class="text-right cursor_pointer"
                    style="padding-right:1.6rem !important"
                    v-if="
                        RoutePermission(false, '', '', 'pricelists', 'update')||RoutePermission(false, '', '', 'pricelists', 'delete')
                      "
                  >
                    <b-dropdown
                      right
                      toggle-class="text-decoration-none"
                      variant="link"
                      no-caret
                      size="xs"
                      class="table-hover-visible last-td-arrow"
                    >
                      <template slot="button-content">
                        <i
                          class="glyphicon glyphicon-option-vertical theme-text-color"
                          style="top:-6px !important;letter-spacing:-5px !important"
                        ></i>
                      </template>
                      <template v-if="RoutePermission(false, '', '', 'pricelists', 'update')">
                        <b-dropdown-item
                          class="event-link"
                          :to="{
                        name: 'PriceListUpdate',
                        params: { id: item.pricing_hdr_id },
                      }"
                        >Edit</b-dropdown-item>
                        <span
                          @click="
                        changePriceListStatus(
                          item,
                          item.pricing_hdr_id,
                          item.status == 1 ? '0' : '1'
                        )
                      "
                          class="event-link dropdown-item"
                        >
                          Mark as
                          {{ item.status == 1 ? "Inactive" : "Active" }}
                        </span>
                      </template>
                      <span
                        v-if="RoutePermission(false, '', '', 'pricelists', 'delete')"
                        class="event-link dropdown-item"
                        v-b-modal.pricinglistdelete
                        @click="delete_id = item.pricing_hdr_id"
                      >Delete</span>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
            <nav class="float-right px-pad" v-if="typeof lists != 'undefined' && lists.length > 0">
              <ul class="pagination" style="cursor:pointer">
                <li
                  :style="
                  parseInt(page) == 1 ? 'pointer-events:none;opacity : 0.8' : ''
                "
                  class="page-item"
                  @click="getPricingLists($route, parseInt(page) - 1, 10)"
                >
                  <span
                    aria-hidden="true"
                    class="fw-semi-bold fa fa-angle-left mr-2"
                    style="margin-bottom : 4px"
                  ></span>
                </li>
                <li class="page-item">
                  {{ (page - 1) * show + 1 || 0 }} to
                  {{ (page - 1) * show + lists.length }}
                </li>
                <li
                  :style="
                  parseInt(next_record) == 0
                    ? 'pointer-events:none;opacity : 0.8'
                    : ''
                "
                  class="page-item"
                  @click="getPricingLists($route, parseInt(page) + 1, 10)"
                >
                  <span
                    aria-hidden="true"
                    class="fw-semi-bold fa fa-angle-right ml-2"
                    style="margin-bottom : 4px"
                  ></span>
                </li>
              </ul>
            </nav>
            <span
              class="float-left text-link fw-semi-bold"
              style="cursor:pointer;padding-left: 1.7rem !important;"
              @click="getTotalCount()"
            >Total Count : {{ total_count || "" }}</span>
          </div>
        </b-col>
      </b-row>
      <!-- Modal for add or edit reporting tag -->

      <!--  delete modal -->

      <b-modal
        :no-close-on-backdrop="true"
        id="pricinglistdelete"
        size="md"
        body-class="bg-white"
        cancel-title="Cancel"
        cancel-variant="light"
        :ok-title-html="submitted == true ? loaderIcon + 'yes' : 'yes'"
        title="Delete Price List"
        ref="delete"
        @ok="deletePriceList()"
        :ok-disabled="submitted"
      >
        <p>Are you sure about deleting selected Price list?</p>
      </b-modal>
    </div>
    <LogRecord :message="logrecords"></LogRecord>
  </div>
</template>
<script>
// import all the components, files and funciton
import { mapState } from "vuex"; // get data set in the state in vuex
import store from "@/store/index"; // vuex store fucntion
import RecordNotFound from "@/pages/Error/RecordNotFound";
import { notificationMixin } from "@/mixins/notification"; // global function for calling notification
import LogRecord from "@/components/Modal/ErrorList"; // modal for deleting created credit used record
function getPricingInitialLists(routeTo, next) {
  const status =
    routeTo.query.status || store.state.pricinglist.index_status || "";
  const search = routeTo.query.search || "";
  const label = routeTo.query.label || "";
  const sort = routeTo.query.sort || "";
  store
    .dispatch("pricinglist/fetchLists", {
      page: 1,
      show: 10,
      search: search,
      status: status,
      sort: sort,
      label: label
    })
    .then(response => {
      if (search != "" && response.data.code == 201) {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: "danger",
          showCloseButton: true
        });
      }
      routeTo.params.status = status;
      routeTo.params.search = search;
      routeTo.params.label = label;
      routeTo.params.sort = sort;
      next();
    });
}
export default {
  mixins: [notificationMixin], //call the global mixin function
  name: "PriceList",
  props: {
    label: [String, Number],
    sort: [String, Number],
    search: [String, Number],
    status: [String, Number]
  },
  data() {
    return {
      logrecords: "",
      delete_id: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      report_tag: {},
      error_msg: false,
      option_duplicate: false,
      error_show: false
    };
  },
  components: {
    RecordNotFound,
    LogRecord
  },
  methods: {
    getTotalCount() {
      this.$store
        .dispatch("pricinglist/totalcount", this.$route.query)
        .then(response => {
          if (this.status_code == 400) {
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: response.data.status,
              type: "danger",
              showCloseButton: true
            });
          }
        });
    },
    getPresentValue(arr, prop, val, result) {
      var hasMatch = "";
      if (arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i][prop] == val) {
            hasMatch = arr[i][result];
            break;
          }
        }
      }
      return hasMatch;
    },
    createFreshData() {
      return {
        status: 1
      };
    },
    changePriceListStatus(item, id, status) {
      
      this.$store
        .dispatch("pricinglist/changeStatus", {
          pricing_hdr_id: id,
          status: status
        })
        .then(() => {
           if(this.status_code == 200){
             item.status = status;
          }
          //to show the alert message for success or error after api call
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message,
            type: this.type,
            showCloseButton: true
          });
          this.getPricingLists(this.$route, this.page, this.show);
        });
                  

    },
    deletePriceList() {
      this.submitted = true;
      this.$store
        .dispatch("pricinglist/deletepricelist", {
          id: this.delete_id
        })
        .then(() => {
          //to show the alert message for success or error after api call
          // if (this.status_code == 200) {
          //   this.logrecords =
          //     this.message.message.length == 0
          //       ? this.message.success
          //       : this.message.message;
          //   this.$root.$emit("bv::show::modal", "loglist");
          // } else {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.status_type,
            showCloseButton: true
          });
          // }

          this.getPricingLists(this.$route, this.page, this.show);
          this.submitted = false;
        });
    },
    getPricingLists(routeTo, page, show) {
      const status = routeTo.query.status || "";
      const search = routeTo.query.search || "";
      const label = routeTo.query.label || "";
      const sort = routeTo.query.sort || "";
      page = page || 1;
      show = show || 10;
      this.$store
        .dispatch("pricinglist/fetchLists", {
          page: page,
          show: show,
          search: search,
          status: status,
          sort: sort,
          label: label
        })
        .then(() => {
          routeTo.params.status = status;
          routeTo.params.search = search;
          routeTo.params.label = label;
          routeTo.params.sort = sort;
          if (this.lists.length == 0 && page != 1) {
            this.getPricingLists(this.$route, this.page - 1, this.show);
          }
        });
    }
  },
  //routing
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch("pricinglist/fetchPriceListDetails");
    getPricingInitialLists(routeTo, next);
  },
  //routing
  beforeRouteUpdate(routeTo, routeFrom, next) {
    store.state.pricinglist.index_status = "";
    getPricingInitialLists(routeTo, next);
  },
  beforeRouteLeave(to, from, next) {
    store.state.pricinglist.pricelist_index_history = from.fullPath;
    store.state.pricinglist.index_status = from.params.status;
    next();
  },

  //computed properties
  computed: {
    ...mapState({
      lists: state => state.pricinglist.lists,
      filter_list: state => state.pricinglist.filter_list,
      filter_name: state => state.pricinglist.filter_name,
      is_no_records: state => state.pricinglist.is_no_records,
      message: state => state.pricinglist.message,
      details: state => state.pricinglist.details,
      total_count: state => state.pricinglist.total_count,
      page: state => state.pricinglist.page,
      show: state => state.pricinglist.show,
      next_record: state => state.pricinglist.next_record,
      type: state => state.pricinglist.type,
      search_criteria: state => state.pricinglist.search_criteria,
      status_code: state => state.pricinglist.status_code,
      status_message: state => state.pricinglist.status_message,
      status_type: state => state.pricinglist.status_type
    })
  }
};
</script>
